import React from 'react';
import { useSelector } from 'react-redux';
import FinancialEntryEdit from './FinancialEntryEdit';
import FinancialEntryInvoiceEdit from './FinancialEntryInvoiceEdit';

const FinancialEntryEditManager = (props) => {
  const { editingInvoice, editing } = useSelector(
    (c) => c.resources['financial-entries'] ?? {}
  );

  if (!editing) {
    return null;
  }

  return editingInvoice ? (
    <FinancialEntryInvoiceEdit {...props} />
  ) : (
    <FinancialEntryEdit {...props} />
  );
};

export default FinancialEntryEditManager;
